import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';
import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AuthenticationType, IViolation, shellStringResources, Credential, azureDefaultAuthRefTypes, azureCloudTypeDef } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';

@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStore.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureDataLakeStore_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureDataLakeStore_DisplayText)
    ]
})
export class AzureDataLakeStoreLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public static readonly DATA_LAKE_STORE_URL: IAttribute;
    public static readonly SUBSCRIPTION_ID: IAttribute;
    public static readonly RESOURCE_GROUP_NAME: IAttribute;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;
    public static readonly TENANT: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccountURI,
        association: 'DATA_LAKE_STORE_URL',
        templatable:true
    })
    public dataLakeStoreUri: string;

    @Metamodel.attribute({
        display: stringResources.SubscriptionId,
        association: 'SUBSCRIPTION_ID',
        templatable:true
    })
    public subscriptionId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ResourceGroupName,
        association: 'RESOURCE_GROUP_NAME',
        templatable:true
    })
    public resourceGroupName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        templatable:true
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        association: 'SERVICE_PRINCIPAL_KEY',
        templatable:true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable:true
    })
    public tenant: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AzureCloudType
    })
    public azureCloudType?: azureCloudTypeDef;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: AzureDataLakeStoreLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    public authReferenceMethod?: string = azureDefaultAuthRefTypes.InlineRefTypeAuthentication;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedservice: AzureDataLakeStoreLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice && (linkedservice.authenticationType === AuthenticationType.UserAssignedManagedIdentity ||
            (linkedservice.authenticationType === AuthenticationType.ServicePrincipal &&
                linkedservice.authReferenceMethod === azureDefaultAuthRefTypes.CredentialRefTypeAuthentication) ||
            (linkedservice.authenticationType === AuthenticationType.UserAuth && GlobalVariables.enableConnectorUserAuthCred)) &&
            !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
